import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { calificacionesPendientes } from "../../utils/Datos";
import { PlaceholderTabla } from "../Otros/Placeholder";
import { Tabla } from "../Otros/Tabla";


export const PorCalificar = ({ procesoActivo, sesionActiva,setCantidad }) => {
  const [cargando, setCargando] = useState(false);
  const [datos, setDatos] = useState();
  let navigate = useNavigate();
 
  
  useEffect(() => {
    if (procesoActivo != null && typeof procesoActivo != "undefined") {
      setCargando(true);
      calificacionesPendientes(procesoActivo.id_process).then((respuesta) => {
        if (respuesta.status === true) {
          setDatos(respuesta.datos);
          setCantidad(respuesta.datos.length);
        } else {
          Swal.fire({
            title: "Error",
            text: "Ocurrió un error al cargar el listado de calificaciones pendientes",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
        setCargando(false);
      });
    }


  }, [procesoActivo]);



  const handleClick = (id_participant, id_prequalifications) => {
    const url = `/ratificar/${id_participant}/${id_prequalifications}/${sesionActiva["id_session"]}`;
    navigate(url, {});
  };

  return cargando || datos == null ? (
    <PlaceholderTabla></PlaceholderTabla>
  ) : (
    
     <Tabla
     columnas={[
       {
         name: "Etapa",
         selector: (row) => (
           <span style={{ whiteSpace: "normal" }}>{row.id_stages}</span>
         ),
         sortable: true,
         maxWidth: "100px",
       },
       {
         name: "Rut",
         selector: (row) => (
           <span style={{ whiteSpace: "normal" }}>{row.rutOfficer}</span>
         ),
         sortable: true,
       },
       {
         name: "Nombre",
         selector: (row) => (
           <span style={{ whiteSpace: "normal" }}>{row.nameOficcer}</span>
         ),
         sortable: true,
       },
       {
         name: "Dirección",
         selector: (row) => (
           <span style={{ whiteSpace: "normal" }}>
             {row.nameDmunicipal}
           </span>
         ),
         sortable: true,
       },
       {
         name: "Unidad",
         selector: (row) => (
           <span style={{ whiteSpace: "normal" }}>
             {row.nameUmunicipal}
           </span>
         ),
         sortable: true,
       },
       sesionActiva!=null && sesionActiva!=false && {
         name: "Ratificar",
         selector: (row) => (
           <button
             type="button"
             className="btn btn-sm btn-primary"
             onClick={() =>
               handleClick(row.id_participant, row.id_qualifications)
             }
           >
             Ratificar
           </button>
         ),
         sortable: false,
         minWidth: "150px",
       },
     ]}
     datos={datos}
     comparacion={(item, filterText) =>
       (item.rutOfficer &&
         item.rutOfficer
           .toLowerCase()
           .includes(filterText.toLowerCase())) ||
       (item.nameOficcer &&
         item.nameOficcer.toLowerCase().includes(filterText.toLowerCase()))
     }
   ></Tabla>
  );
};
